import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
    buttonsContainer: {
        width: 'fit-content',
        borderRadius: '10px',
        background: '#FFDFD3',
    },
});
